module.exports = __webpack_public_path__ + "img/WaLogin-Verif-BG.3c3403d3.svg";